// extracted by mini-css-extract-plugin
module.exports = {"block":"style-module--block--1FePH","image":"style-module--image--2n6GO"};